import React, {useEffect, useState} from 'react'
import Layout from '../../../components/layout/Layout'
import OtpInput from 'react-otp-input';
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from 'react-router-dom';
import {sendData} from "../../../store/actions";
import {createCookie} from 'ubs-framework/v2/common/function';
import {constant} from "../../../common/constant";
import useSocket from "../../common/useSocket";
import AppHeader from "../../common/components/app-header";
import * as Icon from "ubs-icons";
import 'react-toastify/dist/ReactToastify.css';
import {showToastSuccess} from "ubs-framework/v2/common/function";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

function VerifyEmail() {
    const history = useHistory();
    const dispatch = useDispatch()
    const _EMAIL = useSelector(e => e.common?.email)
    const [otp, setOTP] = useState('');
    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);

    const {on, off, refresh} = useSocket(res => {
        setDisabledBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'activateAccount':
                    createCookie('ubs_token', res.data.token, constant.COOKIE_DAYS)
                    createCookie('ubs_email', res.data.email, constant.COOKIE_DAYS)
                    history.push("/workspace")
                    break;
                case 'resendOTP':
                    showToastSuccess("OTP sent successfully.")
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res.data.error)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    useEffect(() => {
        if (_EMAIL?.length === 0) history.push('/login')
        on();
        return () => off()
    }, [])

    const changeOTP = otp => {
        setOTP(otp)
    }
    const verify = () => {
        setDisabledBtn(true)
        sendData(dispatch, 'activateAccount', {otp: otp, email: _EMAIL});
    }
    const resendOTP = () => {
        sendData(dispatch, 'resendOTP', {email: _EMAIL});
    }

    return (
        <React.Fragment>
            <Layout module="verify-email">

                <div className="u_account-form">
                    <Commonrightcircle/>
                    <AppHeader header="Verify Your Email" title={`We’ve sent you a six digit verification OTP at <span>${_EMAIL}</span>`}/>
                    <div className={`u_otp ${errorMsg ? 'u_mb-15' : 'u_mb-30'}`}>
                        <OtpInput
                            value={otp}
                            onChange={changeOTP}
                            isInputNum={true}
                            containerStyle={'u_otp-container'}
                            inputStyle={'u_otp-input'}
                            numInputs={6}
                            shouldAutoFocus={true}
                            separator={<span> </span>}
                        />
                    </div>

                    {errorMsg.length !== 0 && <p className="u_error-message u_mb-15">{errorMsg}</p>}
                    <div className="u_block u_relative">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={verify}
                            className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.VERIFY_EMAIL.SUBMIT_BUTTON}>Submit </button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>

                    <p className="u_send-code u_t-center u_mt-20">Didn’t receive the OTP ? <span className="u_cp" onClick={resendOTP} data-testid={TEST_ID.VERIFY_EMAIL.RESEND_OTP_LINK} >Resend OTP</span>
                    </p>
                </div>
            </Layout>
        </React.Fragment>
    );
}

export default VerifyEmail

